export interface StandardInstruction {
  section: string;
  title: string;
}

export const standardInstructionsUrl = 'https://kls.soludyne.net/Properties.aspx?Q=792644023&C=2';

// Copied from "Instrukser KLS-D" in KLS. Update this list when instructions are added or removed there.
export const standardInstructions: StandardInstruction[] = [
  ...[
    '01 - Opmærkning af arbejdsområde Indendørs',
    '02 - Opmærkning af arbejdsområde Udendørs',
    '03 - Fælles 1-60 kV Måletilladelse',
    '04 - Fælles - Test af afregningsudstyr'
  ].map((title) => ({ section: 'Fælles (0,4-60 kV)', title })),
  ...[
    '02 HSP - Kontrol af Spændingsløs tilstand',
    '05 HSP - Sikkerhedsklipning af frakoblet højspændingskabel',
    '10 HSP - Jording og kortslutning af 60kV HSP',
    '11 HSP - Arbejde vedr. strøm- og spændingstransformer nær ved anlæg under spænding',
    '12 HSP - Betjening af udendørs 60 kV adskiller',
    '13 HSP - Fasevinkelmåling i åbne 60 kV anlæg',
    '14 HSP - Transporter og arbejde under og ved luftledning',
    '15 HSP - Vedligeholdelsesarbejde på NAL og NEB-anlæg på 60/10-20 kV. stationer',
    '16 HSP - Funktionstest og afprøvning af relæ for 60 kV afbryder',
    '17 HSP - Anvendelse af DSO i forbindelse med arbejdstilladelser',
    '18 HSP - Instruks for udtagelse af trådprøver',
    '19 HSP - Planlægning af arbejde i nærheden af elektriske anlæg',
    '20 HSP - Skovning under luftledninger',
    '21 MSP - Arbejde på 60 kV luftledning'
  ].map((title) => ({ section: 'HSP (60 kV)', title })),
  ...[
    '01 LSP - AUS arbejde i kabelskab og transformerstationer',
    '02 LSP - Gøre Kabelskabe og lavspændingsanlæg er spændingsløse',
    '03 LSP - AUS Støvsugning af laspændingsanlæg',
    '05 LSP - Sikkerhedsklipning af lavspændingskabel',
    '06 LSP - Tilslutning af LSP nødkabel',
    '07 LSP - AUS arbejde lavspænding',
    '08 LSP - Kontrol af Spændingsløs tilstand'
  ].map((title) => ({ section: 'LSP (0,4 kV)', title })),
  ...[
    '01 MSP - AUS Støvsugning af højspændingsanlæg',
    '02 MSP - Kontrol af spændingsløs tilstand',
    '03 MSP - Kontrol af spændingsløs tilstand - Luftledning',
    '04 MSP - Arbejdsopgaver på eller ved MSP-transformer',
    '05 MSP - Sikkerhedsklipning af frakoblet mellemspændingskabel',
    '06 MSP - Kabeltest',
    '10 MSP - Jording af stationsanlæg',
    '11 MSP - Jording (endepunkt) ved særlige opgaver',
    '11A MSP - Midlertidig Instruks Jording (endepunkt) ved eftermontering af motor i 8DJH anlæg',
    '12 MSP - Jording af luftledningsanlæg',
    '13 MSP - Betjening af ELA-12 anlæg',
    '14 MSP - Betjening af Krone og Magnefix-MD4 anlæg',
    '15 MSP - Demontering og montering af afdækning',
    '16 MSP - Betjening af adskiller med ringarm ved hjælp af isolerstang',
    '17 MSP - Inspektion af 10 kV-kabel endemuffers oliestand i ELA 12-anlæg',
    '19 MSP - Betjening af 15kV på 10kV anlæg',
    '21 MSP - Tilbagestilling af kortslutningsindikator',
    '22 MSP - Tilbagestilling af termometer på transformer',
    '23 MSP - Tilbagestilling af visertermometer på transformer',
    '24 MSP - Motionering af væskefyldte kortslutningsindikatorer',
    '26 MSP - Fjernelse af fremmedlegemer fra åbne anlæg (luftledning)',
    '28 MSP - Demontering af kabler i celler med 2 kabler',
    '30 MSP - Jordfejlstest med ”skarp jord”',
    '31 MSP - Måling på slukkespole',
    '40 MSP - Sammenfasning i åbne anlæg',
    '41 MSP - Sammenfasning i muffehul',
    '42 MSP - Sammenfasning af kulstofisolerede anlæg',
    '50 MSP - Udskiftning af sikringer i lukkede anlæg',
    '51 MSP - Udskiftning af sikringer på NAL anlæg',
    '52 MSP - Udskiftning af sikringer på RGC anlæg',
    '53 MSP - Udskiftning af sikringer under spænding luftledningsanlæg',
    '54 MSP - Udskiftning af sikringer af 10 kV sikringer med 15kV driftsspænding',
    '61 MSP - Arbejde på Magnefix, Krone (kunststof-isolerede) anlæg',
    '62 MSP - Jording (endepunkt) ved smøring af kugle i 3 CD afbryder'
  ].map((title) => ({ section: 'MSP (10-20 kV)', title }))
];
